export default __webpack_public_path__ + "static/media/microsoft.22c7655b.svg";